import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Collection list',
  icon: 'apps',
  type: 'expo-list',
  tag: 'setup & tools',
  content: {
    entityListId: '',
    minGridWith: 3,
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
